import { render, staticRenderFns } from "./SymbolTicker.vue?vue&type=template&id=2a5a70f1&scoped=true"
import script from "./SymbolTicker.vue?vue&type=script&lang=js"
export * from "./SymbolTicker.vue?vue&type=script&lang=js"
import style0 from "./SymbolTicker.vue?vue&type=style&index=0&id=2a5a70f1&prod&lang=scss&scoped=true"
import style1 from "./SymbolTicker.vue?vue&type=style&index=1&id=2a5a70f1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5a70f1",
  null
  
)

export default component.exports